import { IconSearch } from "@tabler/icons-react";
import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, TextInput, Textarea, Button, Modal, Stack, Badge, Divider, PinInput, Drawer } from "@mantine/core";
import { Table, Flex, Tag, Space, message, Descriptions, Row, Col, Select, Input } from 'antd';
import { useEffect, useState } from "react";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { Find_Retailer_by_mobile_for_wtow_transfer, Get_Ret_to_Ret_wallet_transfer_history, Ret_to_Ret_wallet_transfer } from "../../../apicall";
import dayjs from "dayjs";
import { useWallet } from "../../../Context/Walletcontext";

const { Search } = Input;




const Wtowretailer = ({ Headername }) => {

    const { user } = Userauthcontexthooks();
    const {refreshWallet}= useWallet();
    const [transferMobile, setTransferMobile] = useState('');
    const [transferInputs, setTransferInputs] = useState({
        amount: '',
        remarks: '',
    })
    const [mpin, setMpin] = useState("");
    const [retailerDetails, setRetailerdetails] = useState('');
    const [retailerfindloading, setRetailerfindloading] = useState(false);
    const [transferLoading, setTransferLoading] = useState(false);
    const [mpinModal, setMpinModal] = useState(false);
    const [historyLoading, setHistoryLoading] = useState(true);
    //const [transferHistory, setTransferHistory] = useState([]);
    const [transferDrawer, setTransferDrawer] = useState(false);
    const [selectedTransfer, setSelectedTransfer] = useState(null);
    const [walletTransferHistory, setWalletTransferHistory] = useState([]);
    const [filteredWalletTransferHistory, setFilteredWalletTransferHistory] = useState([]);

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("ALL");

    const handleSearch = () => {

        let filtered = [...walletTransferHistory];

        // Status Filter
        if (status !== "ALL") {
            filtered = filtered.filter(
                item => item.status === status
            );
        }

        // Transfer ID / User Code Search
        if (search.trim()) {

            const keyword = search.trim().toLowerCase();

            filtered = filtered.filter(item =>
                item.TransferId?.toLowerCase().includes(keyword) ||
                item.toDetails?.usercode?.toLowerCase().includes(keyword)
            );
        }

        setFilteredWalletTransferHistory(filtered);
    };

    const handleReset = () => {
        setSearch("");
        setStatus("ALL");
        setFilteredWalletTransferHistory(walletTransferHistory);
    };

    const handleTransferInputChange = (e) => {
        const { name, value } = e.target;
        setTransferInputs((prevInputs) => ({
            ...prevInputs,
            [name]: value,
        }));
    }

    const FindRetailer_forTransfer = async () => {
        if (transferMobile === '') {
            message.error('Please enter retailer mobile number');
            return;
        }
        try {
            setRetailerfindloading(true);
            const data = await Find_Retailer_by_mobile_for_wtow_transfer(transferMobile);
            if (data.success) {
                // console.log(data);

                setRetailerdetails(data?.retailer);
            }
        } catch (error) {
            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setRetailerfindloading(false);
        }
    }

    const handleTransferSubmit = () => {
        const { amount } = transferInputs;
        if (amount === '' || isNaN(amount) || parseFloat(amount) <= 0) {
            message.error('Please enter a valid transfer amount.');
            return;
        }
        if (retailerDetails === '') {
            message.error('Please find retailer details first.');
            return;
        }
        // call the mpin modal
        setMpinModal(true);
    }

    const fetchWalletTransferHistory = async () => {
        try {
            const data = await Get_Ret_to_Ret_wallet_transfer_history();
            if (data.success) {
                //console.log(data);
                setWalletTransferHistory(data.transferHistory);
                setFilteredWalletTransferHistory(data.transferHistory);
                //setTransferHistory(data?.transferHistory);
            }

        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setHistoryLoading(false);
        }
    }

    const confirmTransfer = async () => {
        if (mpin === '' || mpin.length !== 6) {
            message.error("Please enter your 6 digit MPIN");
            return;
        }
        const transferDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
        const body = {
            transferDate,
            amount: transferInputs.amount,
            remarks: transferInputs.remarks,
            mobile: retailerDetails.mobile,
            username: retailerDetails.userName,
            usercode: retailerDetails.userCode,
            userId: retailerDetails._id,
            usertype: retailerDetails.acc_type,
            mpin
        }
        // console.log(body);

        try {

            setTransferLoading(true);

            // API CALL HERE
            const data = await Ret_to_Ret_wallet_transfer(body);
            if (data.success) {
                message.success(data.message);
                setMpinModal(false);
                setTransferMobile('');
                setTransferInputs({
                    amount: '',
                    remarks: '',
                });
                setMpin('');
                setRetailerdetails('');
                await refreshWallet(); // update the wallet in real time. 
                //Get_User_Wallet_Details(); // wallet update. 
                fetchWalletTransferHistory();
            }

        } catch (error) {

            console.log(error);

            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );

        } finally {
            setTransferLoading(false);
        }

    };

    const columns = [
        {
            title: "S.No",
            key: "sno",
            width: 70,
            render: (_, __, index) => index + 1,
        },
        {
            title: "Transfer ID",
            dataIndex: "TransferId",
            width: 150,
        },
        {
            title: "Retailer",
            dataIndex: ["toDetails", "username"],
            width: 180,
        },
        {
            title: "Retailer Code",
            dataIndex: ["toDetails", "usercode"],
            width: 120,
        },
        {
            title: "Amount",
            dataIndex: "amount",
            align: "right",
            width: 120,
            render: (amount) => (
                <span style={{ fontWeight: 600 }}>
                    ₹ {amount.toLocaleString()}
                </span>
            ),
        },
        {
            title: "Status",
            dataIndex: "status",
            width: 120,
            render: (status) => {
                let color = "default";

                if (status === "SUCCESS") color = "green";
                if (status === "PENDING") color = "orange";
                if (status === "FAILED") color = "red";

                return <Tag color={color}>{status}</Tag>;
            },
        },
        {
            title: "Date",
            dataIndex: "transferDate",
            width: 180,
            render: (date) =>
                dayjs(date).format("DD MMM YYYY, hh:mm A"),
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            width: 100,
            render: (_, record) => (
                <Space>
                    <Button
                        // type="link"
                        variant="outline"
                        size="xs"
                        onClick={() => {
                            setSelectedTransfer(record);
                            setTransferDrawer(true);
                        }}
                    >
                        View
                    </Button>
                </Space>
            ),
        },
    ];

    useEffect(() => {
        const fetchWalletTransferHistory = async () => {
            try {
                const data = await Get_Ret_to_Ret_wallet_transfer_history();
                if (data.success) {
                    //console.log(data);
                    setWalletTransferHistory(data.transferHistory);
                    setFilteredWalletTransferHistory(data.transferHistory);
                }

            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );

            } finally {
                setHistoryLoading(false);
            }
        }
        if (user) {
            fetchWalletTransferHistory();
        }
    }, [user])
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Wallet to Wallet Transfer</Title>
                <Text size="xs">You can transfer fund one retailer to other retailer wallet by mobile number.</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Grid>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 12 }}>
                        <Paper shadow="sm" p={'xs'}>
                            <TextInput label="Retailer Mobile Number" placeholder="1123456789" size="md" withAsterisk rightSection={<IconSearch color="green" onClick={FindRetailer_forTransfer} style={{ cursor: 'pointer' }} />} value={transferMobile} onChange={(e) => setTransferMobile(e.target.value)} name="mobile" maxLength={10} loading={retailerfindloading}/>
                            {retailerfindloading && <Text size="xs" c={'green'}>Searching...</Text>}
                            {retailerDetails && <Group justify="space-between">
                                <TextInput label="Retailer Code" size="sm" disabled value={retailerDetails?.userCode} />
                                <TextInput label="Retailer Name" size="sm" disabled value={retailerDetails?.userName} />
                            </Group>}

                            <TextInput label="Transfer Amount" placeholder="0.00" size="md" withAsterisk mt={'xs'} name="amount" value={transferInputs.amount} onChange={handleTransferInputChange} />
                            <Textarea label="Remarks (Optional)" placeholder="Write description here..." size="md" mt={'xs'} name="remarks" value={transferInputs.remarks} onChange={handleTransferInputChange} />
                            <Button fullWidth variant="light" size="md" mt={'md'} onClick={handleTransferSubmit}>Transfer Amount</Button>
                        </Paper>
                    </Grid.Col>
                    <Grid.Col span={{ xs: 12, sm: 12, md: 12 }}>
                        <Paper shadow="sm" p={'xs'}>
                            <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                                {/* <Col xs={24} md={8}>
                                    <RangePicker
                                        style={{ width: "100%" }}
                                        value={dateRange}
                                        onChange={(value) => setDateRange(value)}
                                        allowClear={false}
                                    />
                                </Col> */}
                                <Col xs={24} md={7}>
                                    <Search
                                        placeholder="Search User Code or Transfer ID"
                                        allowClear
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        onSearch={handleSearch}
                                    />
                                </Col>
                                <Col xs={24} md={4}>
                                    <Select
                                        value={status}
                                        onChange={setStatus}
                                        style={{ width: "100%" }}
                                        options={[
                                            { label: "All Status", value: "ALL" },
                                            { label: "SUCCESS", value: "SUCCESS" },
                                            { label: "PENDING", value: "PENDING" },
                                            { label: "FAILED", value: "FAILED" },
                                        ]}
                                    />
                                </Col>
                                <Col xs={24} md={6}>
                                    <Space>
                                        <Button
                                            type="primary"
                                            onClick={handleSearch}
                                        >
                                            Search
                                        </Button>

                                        <Button
                                            variant="light"
                                            onClick={handleReset}
                                        >
                                            Reset
                                        </Button>

                                        <Button
                                            variant="outline"
                                            onClick={fetchWalletTransferHistory}
                                        >
                                            Refresh
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                            <Table
                                columns={columns}
                                dataSource={filteredWalletTransferHistory}
                                rowKey="_id"
                                bordered
                                size="middle"
                                loading={historyLoading}
                                pagination={{
                                    pageSize: 10,
                                    showSizeChanger: true,
                                }} />
                        </Paper>
                    </Grid.Col>
                </Grid>

            </Container>
            <Modal
                opened={mpinModal}
                onClose={() => setMpinModal(false)}
                title="Confirm Wallet Transfer"
                centered
                radius="md"
                size="md"
            >
                <Stack>

                    <Paper withBorder p="md" radius="md">

                        <Stack gap={8}>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Retailer
                                </Text>

                                <Text fw={600}>
                                    {retailerDetails?.userName}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Retailer Code
                                </Text>

                                <Badge>
                                    {retailerDetails?.userCode}
                                </Badge>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Mobile
                                </Text>

                                <Text>
                                    {retailerDetails?.mobile}
                                </Text>
                            </Group>

                            <Divider />

                            <Group justify="space-between">
                                <Text size="sm" fw={600}>
                                    Transfer Amount
                                </Text>

                                <Text
                                    fw={700}
                                    size="lg"
                                    c="green"
                                >
                                    ₹ {Number(transferInputs.amount).toLocaleString()}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Remarks
                                </Text>

                                <Text>
                                    {transferInputs.remarks || "-"}
                                </Text>
                            </Group>

                        </Stack>

                    </Paper>

                    <Divider />

                    <Stack align="center">

                        <Text fw={600}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setMpin}
                            mask
                            size="lg"
                        />

                    </Stack>

                    <Button
                        fullWidth
                        size="md"
                        loading={transferLoading}
                        // color="green"
                        onClick={confirmTransfer}
                    >
                        Confirm Transfer ₹ {Number(transferInputs.amount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>
            
            <Drawer
                title="Transfer Details"
                placement="right"
                width={500}
                opened={transferDrawer}
                onClose={() => setTransferDrawer(false)}
            >
                {selectedTransfer && (
                    <Descriptions
                        bordered
                        size="small"
                        column={1}
                    >
                        <Descriptions.Item label="Transfer ID">
                            {selectedTransfer.TransferId}
                        </Descriptions.Item>

                        <Descriptions.Item label="Status">
                            <Tag
                                color={
                                    selectedTransfer.status === "SUCCESS"
                                        ? "green"
                                        : selectedTransfer.status === "FAILED"
                                            ? "red"
                                            : "orange"
                                }
                            >
                                {selectedTransfer.status}
                            </Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Transfer Date">
                            {dayjs(selectedTransfer.transferDate).format(
                                "DD MMM YYYY, hh:mm:ss A"
                            )}
                        </Descriptions.Item>

                        <Descriptions.Item label="Transfer Amount">
                            ₹ {selectedTransfer.amount.toLocaleString()}
                        </Descriptions.Item>

                        <Descriptions.Item label="Remarks">
                            {selectedTransfer.remarks || "-"}
                        </Descriptions.Item>

                        {/* <Divider /> */}

                        <Descriptions.Item label="Retailer Name">
                            {selectedTransfer.toDetails?.username}
                        </Descriptions.Item>

                        <Descriptions.Item label="Retailer Code">
                            {selectedTransfer.toDetails?.usercode}
                        </Descriptions.Item>

                        <Descriptions.Item label="Retailer Mobile">
                            {selectedTransfer.toDetails?.mobile}
                        </Descriptions.Item>

                        <Descriptions.Item label="Retailer Type">
                            {selectedTransfer.toDetails?.usertype}
                        </Descriptions.Item>

                        {/* <Descriptions.Item label="Retailer ID">
                            {selectedTransfer.toDetails?.userId}
                        </Descriptions.Item> */}
                    </Descriptions>
                )}
            </Drawer>
        </>
    )
}
export default Wtowretailer;